import React from "react";
import ReactToPrint from "react-to-print";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import axios from "../axios";
import "react-datepicker/dist/react-datepicker.css";

class CrfForm extends React.Component {
  state = {
    records: [],
    user: {},
    userId: "",
    medicalData: [],
    surgicalHistoryData: [],
    clinicalTestData: [],
    symptoms: [],
    study_data: [],
  };

  componentDidMount = () => {
    // console.log("this.props.match.params.patientId");
    console.log(this.props.props);
    const userid = this.props.props.match.params.patientId;

    let formdata = new FormData();
    formdata.append("patientId", userid.toString());
    formdata.append("doctorId", this.props.props.match.params.doctorId);

    axios({
      method: "POST",
      url: `/getPatientRecords`,
      data: formdata,
      headers: {
        accessToken: localStorage.accessToken,
      },
    })
      .then((response) => {
        console.log("here", response.data);
        //when ever we use set state before that we need to create variable in state
        this.setState({
          user: response.data.patientDetails,
          records: response.data.records,
          personHistory: response.data.patientDetails.personnel_history,
          study_data: response.data.patientDetails.study_data,
          medicalData: response.data.patientDetails.medicationHistory
            ? JSON.parse(response.data.patientDetails.medicationHistory)
            : [],
          surgicalHistoryData: response.data.patientDetails.surgicalHistory
            ? JSON.parse(response.data.patientDetails.surgicalHistory)
            : [],
          clinicalTestData: response.data.patientDetails.clinicalTest
            ? JSON.parse(response.data.patientDetails.clinicalTest)
            : [],
          symptoms: response.data.records[0].symptoms,
        });

        console.log("user data", this.state.user);
        console.log("record", this.state.records);
        console.log("personhistory", this.state.personHistory);
        console.log("study-data", this.state.study_data);
        console.log("Medical history", this.state.medicalData);
        console.log("surgical data", this.state.surgicalHistoryData);
        console.log("clinical test data", this.state.clinicalTestData);
        console.log("symtoms", this.state.symptoms);
      })
      .catch((error) => console.log(error));
  };

  render() {
    let data = this.state.user;
    let medicalData = this.state.medicalData;
    let clinicalTestData = this.state.clinicalTestData;
    let records = this.state.records;

    console.log(medicalData);
    return (
      <div className="section-to-print">
        <div className="marginBox">
          <div className="subtitle">
            Protocol No:
            <div className="caseForm">CASE REPORT FORM</div>
            <p>
              Study Title:{" "}
              <span className="description">
                {(() => {
                  if (localStorage.adminId === "cmcadmin@salcit.in") {
                    return (
                      <span>
                        Clinical validation of Swaasa.AI platform for screening,
                        diagnosis and management of respiratory diseases.
                      </span>
                    );
                  } else if (localStorage.adminId == "tbvalidation@amc.com") {
                    return (
                      <span>
                        Use of Swaasa Artificial Intelligence platform for
                        identifying unique cough signature of TB
                      </span>
                    );
                  } else {
                    return (
                      <span>
                        Use of Swaasa Artificial Intelligence platform for
                        identifying unique cough signature of COVID-19
                      </span>
                    );
                  }
                })()}
              </span>
            </p>
            <p>
              Patient Id:
              <span className="description" style={{ marginLeft: "2rem" }}>
                {data.patientId}
              </span>
            </p>
            <p>Did the subject meet all the eligibility criteria: </p>
            <p>Date of Informed consent:</p>
            <div className="caseForm">DEMOGRAPHY</div>
            <p>
              Gender:
              <span className="description" style={{ marginLeft: "10rem" }}>
                {data.gender}
              </span>
            </p>
            {/* <p>
              Date of Birth:
              <span className="description"></span>
            </p> */}
            <p>
              Age (Years):
              <span className="description" style={{ marginLeft: "6.2rem" }}>
                {data.age}
              </span>
            </p>
            <p>
              Weight (Kgs):
              <span className="description" style={{ marginLeft: "5rem" }}>
                {data.weight}
              </span>
            </p>
            <p>
              Height (cms):
              <span className="description" style={{ marginLeft: "4.6rem" }}>
                {data.height}
              </span>
            </p>
            <p>
              Religion:
              <span className="description" style={{ marginLeft: "9rem" }}>
                {data.religion}
              </span>
            </p>
            <p>
              Race:
              <span className="description" style={{ marginLeft: "9rem" }}>
                {data.race}
              </span>
            </p>
            <div className="caseForm">PERSONAL HISTORY</div>
            <p className="description">
              Does the subject have any History of Substance abuse?{" "}
            </p>
            <p className="checkbox">
              <label>
                Yes
                <input
                  type="checkbox"
                  checked={
                    this.state.personHistory
                      ? this.state.personHistory.substanceAbuse === "Yes"
                        ? "checked"
                        : null
                      : null
                  }
                />
              </label>
              <label>
                No
                <input
                  type="checkbox"
                  // value = {this.state.personHistory ? this.state.personHistory.alcoholAbuse : null}
                  checked={
                    this.state.personHistory
                      ? this.state.personHistory.substanceAbuse === "No"
                        ? "checked"
                        : null
                      : null
                  }
                />
              </label>
            </p>
            {/* <p className="description">If Yes, Please specify the Substance:  </p> */}
            <p className="checkbox">
              {/* <label>
                Alcohol
                <input type="checkbox"
                  checked={this.state.personHistory ? this.state.personHistory.substanceTypes.includes('Alcohol') === true ? 'checked' : null : null}
                />
              </label>
              <label>
                Tobacco
                <input type="checkbox"
                  checked={this.state.personHistory ? this.state.personHistory.substanceTypes.includes('Tobacco') === true ? 'checked' : null : null}
                />
              </label>
              <label>
                Drugs (Narcotic)
                <input type="checkbox"
                  checked={this.state.personHistory ? this.state.personHistory.substanceTypes.includes('Drugs') === true ? 'checked' : null : null}
                />
              </label> */}
            </p>
            <p className="description">
              Did the Subject continuing the use of Alcohol?{" "}
            </p>
            <p className="checkbox">
              <label>
                Yes
                <input
                  type="checkbox"
                  checked={
                    this.state.personHistory
                      ? this.state.personHistory.alcoholAbuse === "Yes"
                        ? "checked"
                        : null
                      : null
                  }
                />
              </label>
              <label>
                No
                <input
                  type="checkbox"
                  checked={
                    this.state.personHistory
                      ? this.state.personHistory.alcoholAbuse === "NO"
                        ? "checked"
                        : null
                      : null
                  }
                />
              </label>
            </p>
            <p className="description">
              Duration of Alcohol use:
              <span className="description" style={{ marginLeft: "4.6rem" }}>
                {this.state.personHistory
                  ? this.state.personHistory.alcoholUsageDuration
                  : "NA"}
              </span>{" "}
            </p>
            <p className="description">
              Did the Subject continuing the use of Tobacco?{" "}
            </p>
            <p className="checkbox">
              <label>
                Yes
                <input
                  type="checkbox"
                  checked={
                    this.state.personHistory
                      ? this.state.personHistory.tobaccoAbuse === "Yes"
                        ? "checked"
                        : null
                      : null
                  }
                />
              </label>
              <label>
                No
                <input
                  type="checkbox"
                  checked={
                    this.state.personHistory
                      ? this.state.personHistory.tobaccoAbuse === "NO"
                        ? "checked"
                        : null
                      : null
                  }
                />
              </label>
            </p>
            <p className="description">
              Duration of Tobacco use:
              <span className="description" style={{ marginLeft: "4.6rem" }}>
                {this.state.personHistory
                  ? this.state.personHistory.tobaccoUsageDuration
                  : "NA"}
              </span>
            </p>
            <p className="description">
              Did the Subject continuing the use of Drugs (Narcotic)?{" "}
            </p>
            <p className="checkbox">
              <label>
                Yes
                <input
                  type="checkbox"
                  checked={
                    this.state.personHistory
                      ? this.state.personHistory.narcoticsAbuse === "Yes"
                        ? "checked"
                        : null
                      : null
                  }
                />
              </label>
              <label>
                No
                <input
                  type="checkbox"
                  checked={
                    this.state.personHistory
                      ? this.state.personHistory.narcoticsAbuse === "NO"
                        ? "checked"
                        : null
                      : null
                  }
                />
              </label>
            </p>
            <p className="description">
              Duration of Drugs use:
              <span className="description" style={{ marginLeft: "4.6rem" }}>
                {this.state.personHistory
                  ? this.state.personHistory.narcoticsUsageDuration
                  : "NA"}
              </span>
            </p>
            <p className="description">
              Did the subject having any other personal history?
            </p>
            <p className="checkbox">
              <label>
                Yes
                <input
                  type="checkbox"
                  checked={
                    this.state.personHistory
                      ? this.state.personHistory.personnelHistory === "Yes"
                        ? "checked"
                        : null
                      : null
                  }
                />
              </label>
              <label>
                No
                <input
                  type="checkbox"
                  checked={
                    this.state.personHistory
                      ? this.state.personHistory.personnelHistory === "NO"
                        ? "checked"
                        : null
                      : null
                  }
                />
              </label>
            </p>
            <p className="description">
              If Yes, Please Specify:
              <span className="description" style={{ marginLeft: "4.6rem" }}>
                {this.state.personHistory
                  ? this.state.personHistory.personnelHistoryComments
                  : "NA"}
              </span>
            </p>
            <p className="description">
              Did the subject has active TB in the past?
            </p>
            <p className="checkbox">
              <label>
                Yes
                <input
                  type="checkbox"
                  checked={
                    this.state.personHistory
                      ? this.state.personHistory.active_tb_past === "Yes"
                        ? "checked"
                        : null
                      : null
                  }
                />
              </label>
              <label>
                No
                <input
                  type="checkbox"
                  checked={
                    this.state.personHistory
                      ? this.state.personHistory.active_tb_past === "NO"
                        ? "checked"
                        : null
                      : null
                  }
                />
              </label>
            </p>
            <p className="description">
              Did the subject family member, co-worker or friend has active TB?
            </p>
            <p className="checkbox">
              <label>
                Yes
                <input
                  type="checkbox"
                  checked={
                    this.state.personHistory
                      ? this.state.personHistory
                          .known_person_having_active_tb === "Yes"
                        ? "checked"
                        : null
                      : null
                  }
                />
              </label>
              <label>
                No
                <input
                  type="checkbox"
                  checked={
                    this.state.personHistory
                      ? this.state.personHistory
                          .known_person_having_active_tb === "NO"
                        ? "checked"
                        : null
                      : null
                  }
                />
              </label>
              <label>
                Unknown
                <input
                  type="checkbox"
                  checked={
                    this.state.personHistory
                      ? this.state.personHistory
                          .known_person_having_active_tb === "Unknown"
                        ? "checked"
                        : null
                      : null
                  }
                />
              </label>
            </p>
          </div>

          <div className="subtitle">
            Protocol No
            <div className="caseForm">CASE REPORT FORM</div>
            <div className="caseForm">MEDICAL HISTORY</div>
            <p>
              Are there relevant past and/or concomitant diseases or past
              surgeries to report:
            </p>
            <p className="bulletpoints">
              <ul>
                <li>
                  Event/Diagnosis:
                  <span
                    className="description"
                    style={{ marginLeft: "4.6rem" }}
                  >
                    {this.state.surgicalHistoryData[0]
                      ? this.state.surgicalHistoryData[0].Diagnosis
                      : "NA"}
                  </span>
                </li>
                <li>
                  Start Date:
                  <span
                    className="description"
                    style={{ marginLeft: "4.6rem" }}
                  >
                    {this.state.surgicalHistoryData[0]
                      ? this.state.surgicalHistoryData[0].startDate
                      : "NA"}
                  </span>
                </li>
                <li>
                  End Date:
                  <span
                    className="description"
                    style={{ marginLeft: "4.6rem" }}
                  >
                    {this.state.surgicalHistoryData[0]
                      ? this.state.surgicalHistoryData[0].endDate
                      : "NA"}
                  </span>
                </li>
                <li>
                  Ongoing:
                  <span
                    className="description"
                    style={{ marginLeft: "4.6rem" }}
                  >
                    {this.state.surgicalHistoryData[0]
                      ? this.state.surgicalHistoryData[0].ongoing === false
                        ? "false"
                        : "true"
                      : "NA"}
                  </span>
                </li>
              </ul>
            </p>
            <div className="caseForm">MEDICATION HISTORY</div>
            <p style={{ overflowX: "auto" }}>
              <table>
                <tr>
                  <th>Name of the Drug</th>
                  <th>Dose</th>
                  <th>Start Date DD/MMM/YYYY</th>
                  <th>End Date DD/MMM/YYYY</th>
                  <th>Drug Response</th>
                </tr>
                {medicalData.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>{item.drugName}</td>
                      <td>{item.dose}</td>
                      <td>{item.startDate}</td>
                      <td>{item.endDate}</td>
                      <td>{item.response}</td>
                    </tr>
                  );
                })}
              </table>
            </p>
            <div className="caseForm">Clinical Tests</div>
            <p style={{ overflowX: "auto" }}>
              <table>
                <tr>
                  <th>Test ID</th>
                  <th>Test Name</th>
                  <th>Count</th>
                  <th>Comments</th>
                  <th>Parameters</th>
                  <th>value</th>
                </tr>
                {clinicalTestData.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>{item.test_id}</td>
                      <td>{item.test_name}</td>
                      <td>{item.test_count}</td>
                      <td>{item.comments}</td>
                      <td>
                        {item.parameters.map((item, index2) => (
                          <div key={index2}>{item.test_parameter_name}</div>
                        ))}
                      </td>
                      <td>
                        {item.parameters.map((item, index2) => (
                          <div key={index2}>{item.test_parameter_value}</div>
                        ))}
                      </td>
                    </tr>
                  );
                })}
              </table>
            </p>
            {/* <p style={{overflowX : 'auto'}} >
                        <table>
                       
                        <tr>
                          <th>Name of the Drug</th>
                          <th>Dose</th>
                          <th>Start Date
                            DD/MMM/YYYY</th>
                            <th>End Date
                            DD/MMM/YYYY</th>
                            <th>Drug Response</th>
                        </tr>
                        <tr>
                          <td>Germany</td>
                          <td>Maria Anders</td>
                          <td>Germany</td>
                          <td>Germany</td>
                          <td>Germany</td>
                        </tr>
                      
                      </table>
                    </p> */}
            <div className="caseForm">VITAL SIGNS</div>
            <p>Date of Vital Signs:</p>
            <p className="bulletpoints">
              <ol type="I">
                <li>
                  Respiratory Rate(breaths/ minute):
                  <span className="vitalDescription">
                    {this.state.symptoms.respiratory_rate}
                  </span>
                </li>
                <li>
                  Pulse Rate (beats / minute):
                  <span className="vitalDescription">
                    {this.state.symptoms.pulse_rate}
                  </span>
                </li>
                <li>
                  Blood Pressure(mm/Hg) / (mm/Hg):
                  <span className="vitalDescription">
                    {this.state.symptoms.blood_pressure}
                  </span>
                </li>
                <li>
                  Body Temperature(0F):
                  <span className="vitalDescription">
                    {" "}
                    {this.state.symptoms.temperature_F}
                  </span>
                </li>
                <li>
                  Oxygen Saturation(%):
                  <span className="vitalDescription">
                    {this.state.symptoms.oxygen_saturation}
                  </span>
                </li>
              </ol>
            </p>
            <div className="caseForm">COUGH SOUND RECORD DETAILS</div>
            <p style={{ overflowX: "auto" }}>
              <table>
                <tr>
                  <th>Sound Record</th>
                  <th>Date</th>
                </tr>
                {records.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>{item.recordId}</td>
                      <td>{item.timestamp}</td>
                    </tr>
                  );
                })}
              </table>
            </p>
            {/* <p style={{marginTop:"2rem"}}>Method of collection: </p>
                 <p className="bulletpoints">
                 <ol type="a">
                      <li>Zoom Audio recorder (H1 n): </li>
                      <li>In built mobile microphone: </li>
                      <li>Both (a) & (b): </li>
                    </ol>
                 </p> */}
            {/* <div className="caseForm">ADVERSE EVENT MONITORING</div>
                 
                    <p className="description">Did the subject have any adverse event (AE) or serious adverse event (SAE)?</p>
                      <p className="checkbox">
                      <label>
                        Yes
                          <input type="checkbox"
                           checked={this.state.studyData ? this.state.studyData.adverse_event  === "Yes" ? 'checked': null : null}
                          />
                      </label>
                      <label>
                      No
                          <input type="checkbox"
                          checked={this.state.studyData ? this.state.studyData.adverse_event === "No" ? 'checked': null : null}
                          />
                      </label>
                      </p>
                    <p className="description">If Yes, Please Specify:
                      <span className="description" style={{marginLeft:"4.6rem"}}>{this.state.studyData ? this.state.studyData.adverse_event_details : "NA"}</span>
                    </p> */}
            <div className="caseForm">STUDY COMPLETION DETAILS</div>
            <p className="description">Did the Patient complete the study?</p>
            <p className="checkbox">
              <label>
                Yes
                <input
                  type="checkbox"
                  checked={
                    this.state.study_data
                      ? this.state.study_data.studyCompletion === "Yes"
                        ? "checked"
                        : null
                      : null
                  }
                />
              </label>
              <label>
                No
                <input
                  type="checkbox"
                  checked={
                    this.state.study_data
                      ? this.state.study_data.studyCompletion === "No"
                        ? "checked"
                        : null
                      : null
                  }
                />
              </label>
            </p>
            <p className="description">
              If „Yes‟, Please provide the date of patient completion of the
              study:
              <span className="description" style={{ marginLeft: "4.6rem" }}>
                {this.state.studyData
                  ? this.state.studyData.study_complete_date
                  : "NA"}
              </span>
            </p>
            <p className="description">
              if „No‟, Please provide the date of discontinuation from the
              study:
              <span
                className="description"
                style={{ marginLeft: "4.6rem" }}
              ></span>
            </p>
            <p className="description">
              Reason for the subjects discontinuation from the study:
              <span className="description" style={{ marginLeft: "4.6rem" }}>
                {this.state.studyData
                  ? this.state.studyData.subject_discontinuity_reason
                  : "NA"}
              </span>
            </p>
            <p className="description">If subject Death: </p>
            <p className="description">
              Provide the Date of Death
              <span className="description" style={{ marginLeft: "4.6rem" }}>
                {this.state.studyData
                  ? this.state.studyData.subject_death_date
                  : "NA"}
              </span>
            </p>
            <p className="description">
              Cause of Death:
              <span className="description" style={{ marginLeft: "4.6rem" }}>
                {this.state.studyData
                  ? this.state.studyData.cause_of_death
                  : "NA"}
              </span>
            </p>
            <div className="caseForm">PRINCIPAL INVESTIGATOR STATEMENT</div>
            <p className="description">
              I certify that, I have carefully examined and verified, all
              entries on this case record form, all the information entered on
              to these forms by myself and /or my associates is correct. I was
              personally familiar with the clinical presentation and progress of
              the study participant.{" "}
            </p>
            <p>Principal Investigator’s Name: _______________________</p>
            <p>
              Signature of the Principal Investigator: _______________________
            </p>
            <p>Date of Principal Investigator: __/___/_____ ( DD/MMM/YYYY) </p>
          </div>
        </div>
      </div>
    );
  }
}

class Example extends React.Component {
  render() {
    return (
      <div>
        <ReactToPrint
          trigger={() => (
            <a className="centerAlignment" href="#">
              Print
            </a>
          )}
          content={() => this.componentRef}
        />
        <CrfForm ref={(el) => (this.componentRef = el)} props={this.props} />
      </div>
    );
  }
}

export default Example;
